<template>
  <div class="row">
    <!-- Campos Atividades do Scfv -->

    <form-textarea-editor
      v-model="item.objetivo_especifico"
      grid="12"
      label="Objetivo Especifico"
    />

    <form-textarea-editor
      v-model="item.dinamica"
      grid="12"
      label="Dinâmica/Sintese Desenvolvimento"
    />

    <form-textarea-editor
      v-model="item.materiais_utilizados"
      grid="12"
      label="Materiais a serem utilizados"
    />

    <!-- Campos Atividades do Scfv ou Conteúdo-->
  </div>
</template>

<script>
export default {
  props: ["item"],
  name: "CamposScfv",
};
</script>
